const InitStateNames = {
  appBar: 'appBar',
  bookmarks: 'bookmarks',
  content: 'content',
  currentNumber: 'currentNumber',
  drawer: 'drawer',
  history: 'history',
  hymns: 'hymns',
  search: 'search',
  settings: 'settings',
  subtitles: 'subtitles',
  titles: 'titles',
  alphabeticalIndex: 'alphabeticalIndex'
};
export default InitStateNames;
